// Generated with util/create-component.js
import React from 'react';
import { ITableCellProps } from './Cell.types';

const Cell = ({ children }: ITableCellProps) => (
  <td className="rrui-table__cell">{children}</td>
);

export default Cell;
